/** fonction pour créer des styles (utilisé par Analyse et sketchlayer) */
export { default as ArrowLine } from './ArrowLineStyle'
export { default as Cross } from './CrossStyle'
export { default as Diamond } from './DiamondStyle'
export { default as Highlighter } from './HighlighterStyle'
export { default as Line } from './LineStyle'
export { default as Point } from './PointStyle'
export { default as Polygon } from './PolygonStyle'
export { default as Square } from './SquareStyle'
export { default as Star } from './StarStyle'
export { default as Style } from './StyleStyle'
export { default as Triangle } from './TriangleStyle'
export { default as Icon } from './IconStyle'
